// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bank-sync-table td,
.bank-sync-table th {
    vertical-align: middle;
    font-size: 0.875rem;
}

.bank-sync-preview ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.bank-sync-preview li {
    padding: 4px 0;
    border-bottom: 1px solid #eee;
}

.bank-sync-preview li:last-child {
    border-bottom: none;
}
`, "",{"version":3,"sources":["webpack://./src/Erp/BankSyncList/BankSyncSearch.css"],"names":[],"mappings":"AAAA;;IAEI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".bank-sync-table td,\n.bank-sync-table th {\n    vertical-align: middle;\n    font-size: 0.875rem;\n}\n\n.bank-sync-preview ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n\n.bank-sync-preview li {\n    padding: 4px 0;\n    border-bottom: 1px solid #eee;\n}\n\n.bank-sync-preview li:last-child {\n    border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
